import { IPaginatedResponse } from '@/infra/interfaces/http/http-client';
import { httpClient } from '@/infra/protocols/http';
import { IEpisodeDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisode } from '@/modules/episodes/entities/episode.entity';
import { EpisodeMapper } from '@/modules/episodes/mappers/episode.mapper';

export async function getEpisodes(
  params: GetEpisodesService.Params,
): Promise<GetEpisodesService.Response> {
  const response = await httpClient.get<IEpisodeDTO[], true>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios`,
    {
      params: {
        page: params.page,
      },
      paginated: true,
    },
  );
  return {
    ...response,
    data: response.data.map(EpisodeMapper.toPresentation),
  };
}

export namespace GetEpisodesService {
  export interface Params {
    page: number;
    podcastId: string;
    projectId: string;
  }

  export type Response = IPaginatedResponse<IEpisode[]>;
}
